import { render, staticRenderFns } from "./SecurityTab.vue?vue&type=template&id=ee6c8ae8&scoped=true"
import script from "./SecurityTab.vue?vue&type=script&lang=js"
export * from "./SecurityTab.vue?vue&type=script&lang=js"
import style0 from "./SecurityTab.vue?vue&type=style&index=0&id=ee6c8ae8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee6c8ae8",
  null
  
)

export default component.exports